module.exports = __webpack_public_path__ + "static/media/icon_add-event-danger.054d7e93.svg";